import { render, staticRenderFns } from "./CommandButton.vue?vue&type=template&id=411ff5aa&scoped=true"
import script from "./CommandButton.vue?vue&type=script&lang=js"
export * from "./CommandButton.vue?vue&type=script&lang=js"
import style0 from "./CommandButton.vue?vue&type=style&index=0&id=411ff5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411ff5aa",
  null
  
)

export default component.exports